export default duration => {
  if (!duration) return '0:00';
  const totalSeconds = Math.trunc(duration);
  const rest = totalSeconds % 60;
  const minutes = (totalSeconds - rest) / 60;
  const seconds = rest > 9 ? rest : `0${rest}`;
  return `${minutes}:${seconds}`;
};
